<template>
  <el-dialog
    title="招标文件查阅统计"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    class="dialog"
    width="700px"
  >
    <el-input
      v-model="supplierName"
      class="search-input-inbox"
      placeholder="请输入供应商名称"
      clearable
    >
      <template slot="append">
        <el-button type="primary" @click="searchStatistics()">
          搜索
        </el-button>
      </template>
    </el-input>
    <div class="m-t-10 m-b-10 text-info">
      供应商查阅或者下载招标文件都算已查阅，统计每个招标文件的查阅情况
    </div>
    <jczh-table-content
      border
      :data="listData"
      :option="listOptions"
      pagination
      :page.sync="page"
      :limit.sync="size"
      :total="total"
      :pagination-props="{
        pageSizes: [5, 10, 20, 30]
      }"
      @pagination="searchStatistics()"
    >
      <template v-slot:previewStatus="{ row }">
        <el-tooltip placement="top" popper-class="bid-preview-tooltip">
          <template slot="content">
            <div
              v-for="item in row.totalItemList"
              :key="item.attachmentId"
              class="m-t-10"
            >
              <span>{{ item.attachmentName }}</span>
              <span class="m-l-20">{{
                item.previewed || item.downed ? '已查阅' : '未查阅'
              }}</span>
            </div>
          </template>
          <el-button type="text">
            {{
              previewFileStatusDict.translate(row.viewStatus).label
            }}</el-button>
        </el-tooltip>
      </template>
    </jczh-table-content>
  </el-dialog>
</template>
<script>
import { getBidFileViewLogsApi } from '@/api/procure/invite-bid'

import { previewFileStatusDict } from '@/dictionary/project/bid'
import { getBidFileLogApi } from '@/api/project-view/bidding'
export default {
  props: {
    // 是否是在查询统计中使用
    isStatistics: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      orderId: '',
      attachmentIds: '', // 附件组集合，目前包括招标文件和其他附件

      previewFileStatusDict,

      showDialog: false,
      supplementId: '',
      supplierName: '',
      page: 1,
      size: 5,
      total: 0,
      listData: [],
      listOptions: [
        { label: '供应商名称', prop: 'supplierName', minWidth: 100 },
        {
          label: '联系方式',
          prop: '',
          minWidth: 100,
          filter: value => {
            return `${value.contactUserName} ${value.contactUserPhone}`
          }
        },
        {
          label: '预览下载状态',
          prop: '',
          slotName: 'previewStatus',
          minWidth: 200
        }
      ]
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open(orderId, attachmentIds) {
      this.showDialog = true
      this.orderId = orderId
      this.attachmentIds = attachmentIds
      this.searchStatistics()
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.supplierName = ''
      this.page = 1
      this.size = 5
      this.showDialog = false
    },

    /**
     * 查询招标文件查阅统计
     */
    async searchStatistics() {
      try {
        const queryApi = this.isStatistics
          ? getBidFileLogApi
          : getBidFileViewLogsApi
        const _data = await queryApi(
          {
            attachmentIds: this.attachmentIds,
            supplierName: this.supplierName,
            page: this.page,
            size: this.size
          },
          this.orderId
        )
        this.listData = _data.data?.records || []
        this.total = _data.data?.total || 0
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search-input-inbox {
  width: 400px;
  border: none;
}
::v-deep {
  .el-input-group__append,
  .el-input-group__prepend {
    color: #fff;
    background-color: $primary-color;
  }
}
</style>
<style lang="scss">
.bid-preview-tooltip {
  background: rgba(20, 20, 20, 0.7) !important;
  max-width: 500px;
  text-align: center;
  font-size: 13px;
}
</style>
